import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dialog from '../../common/components/Dialog';
import { Button } from 'react-bootstrap';
import MarkAsCancelledForm from './MarkAsCancelledForm';
import RemoteSubmitButton from '../../common/components/formControls/RemoteSubmitButton';
import { withTranslation } from 'react-i18next';

class MarkAsCancelledDialog extends Component {
	dialogConfig() {
		const { t, onCancel } = this.props;

		return {
			header: t('PaymentHistory_MarkAsCancelled'),
			body: this.renderBody(),
			onHide: onCancel,
			footer: this.renderFooter()
		};
	}

	renderBody() {
		const { onConfirm, isManualInstalment, outstandingTotal, paymentMethod, showWarning } = this.props;
		return <MarkAsCancelledForm onSubmit={onConfirm} initialValues={{ outstandingTotal: outstandingTotal, refundedAmount: 0 }}
			paymentMethod={paymentMethod} showWarning={showWarning} />;
	}

	renderFooter() {
		const { onCancel, t } = this.props;

		const closeBtn = <Button key='close' onClick={onCancel}>{t('Common_Close')}</Button>;
		const confirmBtn = <RemoteSubmitButton key='save' style='primary' formName='markAsCancelled' label={t('PaymentHistory_MarkAsCancelled')} />;
		return [closeBtn, confirmBtn];
	}

	render() {
		const { show, block, unblock } = this.props;
		const dialogConfig = this.dialogConfig();
		return <Dialog config={dialogConfig} show={show} block={block} unblock={unblock} />;
	}
}

MarkAsCancelledDialog.propTypes = {
	show: PropTypes.bool,
	block: PropTypes.oneOfType([
		PropTypes.instanceOf(RegExp),
		PropTypes.string,
		PropTypes.array,
		PropTypes.func
	]),
	unblock: PropTypes.oneOfType([
		PropTypes.instanceOf(RegExp),
		PropTypes.string,
		PropTypes.array,
		PropTypes.func
	]),
	onCancel: PropTypes.func.isRequired,
	onConfirm: PropTypes.func.isRequired
};

export default withTranslation()(MarkAsCancelledDialog);